import { memo } from 'react';

import { PersistentStorageProvider } from '~/common/contexts/PersistentStorageContext';
import { ENVIRONMENT } from '../../constants';
import { useModuleScope } from '../ModuleScopeContext';
import { ALLOWED_KEYS } from './constants/allowedKeys';
import { InceptPersistentStorageProviderProps } from './types/InceptPersistentStorageProviderProps';

const InceptPersistentStorageProviderComponent = ({
  children,
}: InceptPersistentStorageProviderProps) => {
  // Scope persisted storage (auth tokens) to the module the tab is in, so a
  // broker tab and a middle-office tab do not share/overwrite each other's
  // tokens. Resolved by ModuleScopeProvider, above the token lifecycle.
  // useModuleScope normalises Application to BrokerPortal, so both share
  // the same namespace as intended.
  const scope = useModuleScope();

  return (
    <PersistentStorageProvider
      allowedKeys={ALLOWED_KEYS}
      namespace={`incept_${ENVIRONMENT.tenant}_${scope}`}
    >
      {children}
    </PersistentStorageProvider>
  );
};

export const InceptPersistentStorageProvider = memo(
  InceptPersistentStorageProviderComponent,
);
